// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PromoCodeForm-promoCodeInputContainer-penFN {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 8px;
    grid-gap: 8px;
    margin-bottom: 18px;
}

.PromoCodeForm-promoCodeInputContainer-penFN>div:last-child {
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.PromoCodeForm-promoSearchIcon-qZF4r {
    position: absolute;
    width: 22px;
    height: 22px;
    -o-object-fit: contain;
       object-fit: contain;
    top: 50%;
    left: 18px;
    -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
            transform: translateY(-50%);
}

.PromoCodeForm-promoCodeCardList-d2y5M {
    display: grid;
    gap: 12px;
    grid-gap: 12px;
}

.PromoCodeForm-promoCodeCardListItem-sGsj1 {
    background: var(--background-primary);
    -webkit-box-shadow: 0px 4px 10px 0px #0000000A;
            box-shadow: 0px 4px 10px 0px #0000000A;
    border-radius: var(--radius-2);
    padding: 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 12px;
    grid-gap: 12px;
    cursor: pointer;
}

.PromoCodeForm-promoCodeCardLsImgContainer-jATts {
    position: relative;
    width: 60px;
    height: 60px;
    border-radius: var(--radius-1);
    display: inline-block;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.PromoCodeForm-promoCodeCardLsImgContainer-jATts img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center;
    border-radius: inherit;
}

.PromoCodeForm-promoCodeLabel-GDxkc {
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.PromoCodeForm-noPromoDefaultIcon-fjUAD {
    width: 188px;
    height: 172px;
    -o-object-fit: contain;
       object-fit: contain;
    margin: 0 auto;
    display: block;
    margin-bottom: 24px;
}

@media (max-width: 767px) {
    .PromoCodeForm-promoCodeInputContainer-penFN {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: stretch;
            -ms-flex-align: stretch;
                align-items: stretch;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PromoCodeForm/PromoCodeForm.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,8CAAsC;YAAtC,sCAAsC;IACtC,8BAA8B;IAC9B,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,qBAAqB;IACrB,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,0BAAuB;OAAvB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAmB;OAAnB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,0BAAoB;YAApB,uBAAoB;gBAApB,oBAAoB;IACxB;AACJ","sourcesContent":[".promoCodeInputContainer {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    grid-gap: 8px;\n    margin-bottom: 18px;\n}\n\n.promoCodeInputContainer>div:last-child {\n    flex-shrink: 0;\n}\n\n.promoSearchIcon {\n    position: absolute;\n    width: 22px;\n    height: 22px;\n    object-fit: contain;\n    top: 50%;\n    left: 18px;\n    transform: translateY(-50%);\n}\n\n.promoCodeCardList {\n    display: grid;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.promoCodeCardListItem {\n    background: var(--background-primary);\n    box-shadow: 0px 4px 10px 0px #0000000A;\n    border-radius: var(--radius-2);\n    padding: 12px;\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    grid-gap: 12px;\n    cursor: pointer;\n}\n\n.promoCodeCardLsImgContainer {\n    position: relative;\n    width: 60px;\n    height: 60px;\n    border-radius: var(--radius-1);\n    display: inline-block;\n    flex-shrink: 0;\n}\n\n.promoCodeCardLsImgContainer img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    border-radius: inherit;\n}\n\n.promoCodeLabel {\n    flex-shrink: 0;\n}\n\n.noPromoDefaultIcon {\n    width: 188px;\n    height: 172px;\n    object-fit: contain;\n    margin: 0 auto;\n    display: block;\n    margin-bottom: 24px;\n}\n\n@media (max-width: 767px) {\n    .promoCodeInputContainer {\n        flex-direction: column;\n        align-items: stretch;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"promoCodeInputContainer": `PromoCodeForm-promoCodeInputContainer-penFN`,
	"promoSearchIcon": `PromoCodeForm-promoSearchIcon-qZF4r`,
	"promoCodeCardList": `PromoCodeForm-promoCodeCardList-d2y5M`,
	"promoCodeCardListItem": `PromoCodeForm-promoCodeCardListItem-sGsj1`,
	"promoCodeCardLsImgContainer": `PromoCodeForm-promoCodeCardLsImgContainer-jATts`,
	"promoCodeLabel": `PromoCodeForm-promoCodeLabel-GDxkc`,
	"noPromoDefaultIcon": `PromoCodeForm-noPromoDefaultIcon-fjUAD`
};
module.exports = ___CSS_LOADER_EXPORT___;
